export default __webpack_public_path__ + "static/media/336D.92676142.jpg";